// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Role$ReactHooksTemplate = require("./role.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Loading$ReactHooksTemplate = require("../dashboard/dashboard/Loading.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var TextInputNew$ReactHooksTemplate = require("../common/TextInputNew.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var CheckboxStatus$ReactHooksTemplate = require("./checkboxStatus.res.js");
var PermissionTree$ReactHooksTemplate = require("./permissionTree.res.js");

function fetchPermissions(param) {
  return Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/permissions", PermissionTree$ReactHooksTemplate.decode);
}

function getInputValue(x) {
  return x._0;
}

function getValidationError(x) {
  switch (x.TAG) {
    case "Invalid" :
        return x._1;
    case "Valid" :
    case "NotValidated" :
        return /* [] */0;
    
  }
}

function RoleCreate(props) {
  var refreshRoles = props.refreshRoles;
  var toggleRoleCreate = props.toggleRoleCreate;
  var role = props.role;
  var initialState = role !== undefined ? ({
        role: Caml_option.valFromOption(role),
        action: "Update",
        notification: undefined,
        nameError: undefined,
        permissionError: undefined,
        permissionPage: false,
        selectedGroup: undefined
      }) : ({
        role: Role$ReactHooksTemplate.empty(),
        action: "Create",
        notification: undefined,
        nameError: undefined,
        permissionError: undefined,
        permissionPage: false,
        selectedGroup: undefined
      });
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var hasPermission = match$1[0];
  React.useEffect((function (param) {
          if (state.action === "Create") {
            Js_promise.then_((function (permissions) {
                    var updatedRole = Role$ReactHooksTemplate.setPermissions(state.role, permissions);
                    return Promise.resolve(Curry._1(setState, (function (state) {
                                      return {
                                              role: updatedRole,
                                              action: state.action,
                                              notification: state.notification,
                                              nameError: state.nameError,
                                              permissionError: state.permissionError,
                                              permissionPage: state.permissionPage,
                                              selectedGroup: "dashboard"
                                            };
                                    })));
                  }), Http$ReactHooksTemplate.fetchGetJSONDecode("/api/v1/permissions", PermissionTree$ReactHooksTemplate.decode));
          }
          
        }), []);
  var toggleCheckboxState = function (name) {
    var permissions = PermissionTree$ReactHooksTemplate.applyMaskPermissionDependencies(PermissionTree$ReactHooksTemplate.applyReportPermissionDependencies(Belt_List.map(Role$ReactHooksTemplate.permissions(state.role), (function (param) {
                    return PermissionTree$ReactHooksTemplate.toggle(name, param);
                  }))));
    var newRole = Role$ReactHooksTemplate.setPermissions(state.role, permissions);
    var permissionValidation = List.length(Role$ReactHooksTemplate.enabledCapabilities(newRole)) === 0 ? ({
          hd: "can't be blank",
          tl: /* [] */0
        }) : undefined;
    Curry._1(setState, (function (state) {
            return {
                    role: newRole,
                    action: state.action,
                    notification: state.notification,
                    nameError: state.nameError,
                    permissionError: permissionValidation,
                    permissionPage: state.permissionPage,
                    selectedGroup: state.selectedGroup
                  };
          }));
  };
  var filterPermissionsByGroup = function (permissions, selectedGroupName) {
    return List.filter(function (tree) {
                  if (tree.TAG === "Capability") {
                    return false;
                  } else {
                    return tree._0 === selectedGroupName;
                  }
                })(permissions);
  };
  var getAllGroupNames = function (permissionList) {
    var extractTopLevelGroupNames = function (tree) {
      if (tree.TAG === "Capability") {
        return /* [] */0;
      } else {
        return {
                hd: tree._0,
                tl: /* [] */0
              };
      }
    };
    return List.flatten(List.map(extractTopLevelGroupNames, permissionList));
  };
  var capabilityLabel = function (capability) {
    switch (capability) {
      case "mask_values" :
          return "Mask values";
      case "view_mask_values" :
          return "View mask values";
      default:
        return capability;
    }
  };
  var canShowCapability = function (capability) {
    switch (capability) {
      case "mask_values" :
          return Curry._1(hasPermission, "MaskValues");
      case "view_mask_values" :
          if (Curry._1(hasPermission, "MaskValues")) {
            return true;
          } else {
            return Curry._1(hasPermission, "ViewMaskValues");
          }
      default:
        return true;
    }
  };
  var capabilityCheckBoxItem = function (capability, status) {
    if (canShowCapability(capability)) {
      return JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                        checked: CheckboxStatus$ReactHooksTemplate.toBool(status),
                        label: capabilityLabel(capability),
                        handleChange: (function (param) {
                            toggleCheckboxState(capability);
                          })
                      }),
                  className: "pl-5"
                }, capability);
    } else {
      return null;
    }
  };
  var groupCheckboxTree = function (group, status, children) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                        checked: CheckboxStatus$ReactHooksTemplate.toBool(status),
                        label: group,
                        handleChange: (function (param) {
                            toggleCheckboxState(group);
                          }),
                        indeterminate: CheckboxStatus$ReactHooksTemplate.isIndeterminate(status)
                      }),
                  JsxRuntime.jsx("div", {
                        children: Belt_List.toArray(children),
                        className: "pl-5"
                      })
                ]
              }, group);
  };
  var permissionCheckboxTree = function (permissionTree) {
    return PermissionTree$ReactHooksTemplate.postOrder(capabilityCheckBoxItem, groupCheckboxTree, permissionTree);
  };
  var handleNameChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event).toLowerCase();
    Curry._1(setState, (function (state) {
            var updatedRole = Role$ReactHooksTemplate.setName(state.role, value);
            var nameValidation = Role$ReactHooksTemplate.name(updatedRole) === Role$ReactHooksTemplate.emptyString ? ({
                  hd: "Name can't be empty",
                  tl: /* [] */0
                }) : undefined;
            return {
                    role: updatedRole,
                    action: state.action,
                    notification: state.notification,
                    nameError: nameValidation,
                    permissionError: state.permissionError,
                    permissionPage: state.permissionPage,
                    selectedGroup: state.selectedGroup
                  };
          }));
  };
  var handleDescriptionChange = function ($$event) {
    var value = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setState, (function (state) {
            var updatedRole = Role$ReactHooksTemplate.setDescription(state.role, value);
            return {
                    role: updatedRole,
                    action: state.action,
                    notification: state.notification,
                    nameError: state.nameError,
                    permissionError: state.permissionError,
                    permissionPage: state.permissionPage,
                    selectedGroup: state.selectedGroup
                  };
          }));
  };
  var isBasicInfoValid = function (state) {
    var nameErrorCount = Belt_Option.mapWithDefault(state.nameError, 0, List.length);
    return !(Role$ReactHooksTemplate.name(state.role) === Role$ReactHooksTemplate.emptyString || nameErrorCount > 0);
  };
  var isFormNotValid = function (state) {
    var errors = state.nameError;
    var nameErrorCount = errors !== undefined ? List.length(errors) : 0;
    if (Role$ReactHooksTemplate.name(state.role) === Role$ReactHooksTemplate.emptyString || List.length(Role$ReactHooksTemplate.enabledCapabilities(state.role)) === 0) {
      return true;
    } else {
      return nameErrorCount > 0;
    }
  };
  var alertType = state.notification;
  var tmp;
  if (Curry._1(hasPermission, "AddRole")) {
    var tmp$1;
    if (state.permissionPage) {
      var xs = state.permissionError;
      var selectedGroupName = state.selectedGroup;
      tmp$1 = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("p", {
                    children: "Set Role Permissions",
                    className: "mb-2 font-semibold flex-shrink-0"
                  }),
              $$Array.of_list(xs !== undefined ? List.map((function (x) {
                            return JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("p", {
                                              children: x,
                                              className: "text-red-500 text-xs float-left"
                                            }),
                                        className: "my-2 pb-2 flex-shrink-0"
                                      });
                          }), xs) : /* [] */0),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: $$Array.of_list(List.map((function (groupName) {
                                        var selected = state.selectedGroup;
                                        var isSelected = selected !== undefined ? selected === groupName : false;
                                        return JsxRuntime.jsx("button", {
                                                    children: groupName,
                                                    className: "w-full text-left h-12 px-4 py-3 border-b border-gray-200 bg-white capitalize text-sm cursor-pointer focus:outline-none " + (
                                                      isSelected ? "bg-lavenderweb font-semibold" : "hover:bg-gray-100"
                                                    ),
                                                    type: "button",
                                                    onClick: (function ($$event) {
                                                        $$event.preventDefault();
                                                        $$event.stopPropagation();
                                                        Curry._1(setState, (function (state) {
                                                                return {
                                                                        role: state.role,
                                                                        action: state.action,
                                                                        notification: state.notification,
                                                                        nameError: state.nameError,
                                                                        permissionError: state.permissionError,
                                                                        permissionPage: state.permissionPage,
                                                                        selectedGroup: groupName
                                                                      };
                                                              }));
                                                      })
                                                  }, groupName);
                                      }), getAllGroupNames(Role$ReactHooksTemplate.permissions(state.role)))),
                            className: "w-1/3 bg-gray-50 border-r border-gray-300 overflow-y-auto"
                          }),
                      JsxRuntime.jsx("div", {
                            children: selectedGroupName !== undefined ? JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("h3", {
                                            children: selectedGroupName + " Actions",
                                            className: "font-bold text-xl mb-2 capitalize"
                                          }),
                                      JsxRuntime.jsx("h4", {
                                            children: "You can control " + selectedGroupName + " from here",
                                            className: "text-gray-600 mb-6 text-sm"
                                          }),
                                      JsxRuntime.jsx("div", {
                                            children: $$Array.of_list(List.map(permissionCheckboxTree, filterPermissionsByGroup(Role$ReactHooksTemplate.permissions(state.role), selectedGroupName))),
                                            className: "space-y-2"
                                          })
                                    ]
                                  }) : JsxRuntime.jsx("div", {
                                    children: "Select Permissions",
                                    className: "text-gray-500 text-center py-8"
                                  }),
                            className: "w-2/3 bg-white p-6 overflow-y-auto"
                          })
                    ],
                    className: "flex flex-1 min-h-0 mt-2 border border-gray-200 rounded overflow-hidden"
                  })
            ],
            className: "flex flex-col h-full min-h-0"
          });
    } else {
      var xs$1 = state.nameError;
      tmp$1 = JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                    label: "Role name",
                    value: Role$ReactHooksTemplate.name(state.role),
                    handleChange: handleNameChange,
                    maxLength: 100
                  }),
              $$Array.of_list(xs$1 !== undefined ? List.map((function (x) {
                            return JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("p", {
                                              children: x,
                                              className: "text-red-500 text-xs float-right"
                                            })
                                      });
                          }), xs$1) : /* [] */0),
              JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(TextInputNew$ReactHooksTemplate.make, {
                          label: "Description",
                          value: Role$ReactHooksTemplate.description(state.role),
                          handleChange: handleDescriptionChange
                        }),
                    className: "mb-4"
                  })
            ],
            className: "flex flex-col gap-4 overflow-y-auto h-full pr-1"
          });
    }
    var tmp$2;
    if (state.permissionPage) {
      var match$2 = state.action;
      var tmp$3;
      tmp$3 = match$2 === "Create" ? "Create" : "Save";
      tmp$2 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("button", {
                    children: "Back",
                    className: "text-dark border border-bg-black hover:bg-gray-200 py-6-px px-20-px rounded shadow",
                    type: "button",
                    onClick: (function (param) {
                        Curry._1(setState, (function (state) {
                                return {
                                        role: state.role,
                                        action: state.action,
                                        notification: state.notification,
                                        nameError: state.nameError,
                                        permissionError: state.permissionError,
                                        permissionPage: false,
                                        selectedGroup: state.selectedGroup
                                      };
                              }));
                      })
                  }),
              JsxRuntime.jsx("button", {
                    children: tmp$3,
                    className: "bg-palatinateblue border border-gray-400 flex rounded py-3 px-6 text-base font-semibold text-white justify-center " + (
                      isFormNotValid(state) ? "disabled-input" : "cursor-pointer"
                    ),
                    disabled: isFormNotValid(state),
                    type: "button",
                    onClick: (function (param) {
                        var encodedRole = Role$ReactHooksTemplate.encode(state.role);
                        var roleId = Role$ReactHooksTemplate.id(state.role);
                        var params = {};
                        params["role"] = encodedRole;
                        var match = state.action;
                        var submitRole;
                        submitRole = match === "Create" ? Http$ReactHooksTemplate.fetchPostJSON("/api/v1/roles", params) : Http$ReactHooksTemplate.fetchPostJSON("/api/v1/roles/" + String(roleId) + "/update", params);
                        Js_promise.then_((function (response) {
                                var status = Json_decode.field("status", (function (param) {
                                        return Json_decode.withDefault("failure", Json_decode.string, param);
                                      }), response);
                                if (status === "success") {
                                  var match = state.action;
                                  var successMessage;
                                  successMessage = match === "Create" ? "Role Created Successfully" : "Role Updated Successfully";
                                  var alert = {
                                    TAG: "Success",
                                    _0: successMessage
                                  };
                                  Curry._1(setState, (function (state) {
                                          return {
                                                  role: state.role,
                                                  action: state.action,
                                                  notification: alert,
                                                  nameError: undefined,
                                                  permissionError: undefined,
                                                  permissionPage: state.permissionPage,
                                                  selectedGroup: state.selectedGroup
                                                };
                                        }));
                                  if (refreshRoles !== undefined) {
                                    Curry._1(refreshRoles, undefined);
                                  }
                                  setTimeout((function (param) {
                                          if (toggleRoleCreate !== undefined) {
                                            return Curry._1(toggleRoleCreate, undefined);
                                          }
                                          
                                        }), 1000);
                                  window.scrollTo(0.0, 0.0);
                                } else {
                                  var nameError = Json_decode.field("errors", (function (param) {
                                          return Json_decode.optional((function (param) {
                                                        return Json_decode.field("name", (function (param) {
                                                                      return Json_decode.list(Json_decode.string, param);
                                                                    }), param);
                                                      }), param);
                                        }), response);
                                  var permissionError = Json_decode.field("errors", (function (param) {
                                          return Json_decode.optional((function (param) {
                                                        return Json_decode.field("permissions", (function (param) {
                                                                      return Json_decode.list(Json_decode.string, param);
                                                                    }), param);
                                                      }), param);
                                        }), response);
                                  Curry._1(setState, (function (state) {
                                          return {
                                                  role: state.role,
                                                  action: state.action,
                                                  notification: {
                                                    TAG: "Failure",
                                                    _0: "Something went wrong please contact admin"
                                                  },
                                                  nameError: nameError,
                                                  permissionError: permissionError,
                                                  permissionPage: state.permissionPage,
                                                  selectedGroup: state.selectedGroup
                                                };
                                        }));
                                  window.scrollTo(0.0, 0.0);
                                }
                                return Promise.resolve();
                              }), submitRole);
                      })
                  })
            ]
          });
    } else {
      tmp$2 = JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              JsxRuntime.jsx("a", {
                    children: "Cancel",
                    className: "border border-gray-400 flex rounded py-3 px-6 text-base font-semibold justify-center",
                    href: "/roles/all"
                  }),
              JsxRuntime.jsx("button", {
                    children: "Next",
                    className: "bg-palatinateblue border border-gray-400 flex rounded py-3 px-6 text-base font-semibold text-white justify-center " + (
                      isBasicInfoValid(state) ? "cursor-pointer" : "disabled-input"
                    ),
                    disabled: !isBasicInfoValid(state),
                    type: "button",
                    onClick: (function (param) {
                        var match = getAllGroupNames(Role$ReactHooksTemplate.permissions(state.role));
                        var firstGroup = match ? match.hd : undefined;
                        Curry._1(setState, (function (state) {
                                return {
                                        role: state.role,
                                        action: state.action,
                                        notification: state.notification,
                                        nameError: state.nameError,
                                        permissionError: state.permissionError,
                                        permissionPage: true,
                                        selectedGroup: firstGroup
                                      };
                              }));
                      })
                  })
            ]
          });
    }
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: tmp$1,
                  className: "flex-1 min-h-0 overflow-hidden px-8 pt-6"
                }),
            JsxRuntime.jsx("div", {
                  children: tmp$2,
                  className: "flex-shrink-0 border-t border-gray-200 flex font-medium gap-3 justify-end p-5 bg-white"
                })
          ],
          className: "flex flex-col border-t",
          style: {
            height: "min(70vh, 36rem)",
            maxHeight: "calc(90vh - 8rem)"
          }
        });
  } else {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loading$ReactHooksTemplate.make, {
                img: Caml_option.some(Image$ReactHooksTemplate.unAuthorized),
                text: "401: Unauthorized!!",
                loading: false
              }),
          className: "h-screen w-full animated fadeIn"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                alertType !== undefined ? JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                        alertType: alertType,
                        handleClose: (function (param) {
                            Curry._1(setState, (function (state) {
                                    return {
                                            role: state.role,
                                            action: state.action,
                                            notification: undefined,
                                            nameError: state.nameError,
                                            permissionError: state.permissionError,
                                            permissionPage: state.permissionPage,
                                            selectedGroup: state.selectedGroup
                                          };
                                  }));
                          })
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                tmp
              ]
            });
}

var make = RoleCreate;

exports.fetchPermissions = fetchPermissions;
exports.getInputValue = getInputValue;
exports.getValidationError = getValidationError;
exports.make = make;
/* react Not a pure module */
